import { render, staticRenderFns } from "./walker-sitter-component.vue?vue&type=template&id=1be4d211&scoped=true&lang=pug"
import script from "./walker-sitter-component.js?vue&type=script&lang=js&external"
export * from "./walker-sitter-component.js?vue&type=script&lang=js&external"
import style0 from "./walker-sitter-component.vue?vue&type=style&index=0&id=1be4d211&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be4d211",
  null
  
)

export default component.exports